import { snakeCaseObjectKeys } from '@doordash/object-utils';
import * as queryString from 'query-string';
import { readCookie } from './cookie_helper';
import { IDENTITY_SERVICE_AUTH_URL, IDENTITY_SERVICE_BASE_URL, IDENTITY_SERVICE_SIGNUP_URL, IDENTITY_SERVICE_WEB_BFF_CLIENT_ID, IDENTITY_SERVICE_DEFAULT_REDIRECT_BASE_URL, IDENTITY_SERVICE_POST_LOGIN_PATH, IDENTITY_SERVICE_POST_LOGOUT_PATH, PORTAL_ROUTE_PREFIX, } from '../constants/values';
export var DDFB_IDENTITY_LAYOUTS;
(function (DDFB_IDENTITY_LAYOUTS) {
    DDFB_IDENTITY_LAYOUTS["SELF_SERVE"] = "ddfw_self_serve";
    DDFB_IDENTITY_LAYOUTS["BENEFIT_ACTIVATION"] = "ddfb_benefit_activation";
    DDFB_IDENTITY_LAYOUTS["CONSUMER_WEB"] = "consumer_web";
    DDFB_IDENTITY_LAYOUTS["SELF_SERVE_WITH_COMPANY"] = "ddfb_self_serve_company";
})(DDFB_IDENTITY_LAYOUTS || (DDFB_IDENTITY_LAYOUTS = {}));
// Used in DDFB_IDENTITY_LAYOUTS.BENEFIT_ACTIVATION
export var BENEFIT_ACTIVATION_BENEFIT_TYPE;
(function (BENEFIT_ACTIVATION_BENEFIT_TYPE) {
    BENEFIT_ACTIVATION_BENEFIT_TYPE["EM"] = "EM";
    BENEFIT_ACTIVATION_BENEFIT_TYPE["Voucher"] = "Voucher";
})(BENEFIT_ACTIVATION_BENEFIT_TYPE || (BENEFIT_ACTIVATION_BENEFIT_TYPE = {}));
var defaultIdentityUrlOptions = {
    identityMode: 'login',
};
/**
 * generate a redirect_uri that identity service will direct user back
 * after successfully authenciated user
 * @param options
 * @param {string} options.redirectUri if provided, this will be used and passed to IS directly
 * @param {string} options.redirectBaseUrl the fully qualified domain name that IS will redirect user back to
 * @param {string | null | undefined} options.redirectPath the url path user will be redirected to, together with the base url.
 * passing in `null` will redirect user to the root, passing in `undefined` will redirect user to `nextPath`
 * @param {string} options.nextPath the url path user will be redirected to
 */
export var getRedirectUrl = function (_a) {
    var redirectPath = _a.redirectPath, nextPath = _a.nextPath, redirectBaseUrl = _a.redirectBaseUrl, redirectUri = _a.redirectUri;
    if (redirectUri !== undefined) {
        return redirectUri;
    }
    var urlPrefix = redirectBaseUrl || IDENTITY_SERVICE_DEFAULT_REDIRECT_BASE_URL;
    var urlPath = '';
    if (redirectPath === null) {
        urlPath = '';
    }
    else if (redirectPath === undefined) {
        urlPath = nextPath || '';
    }
    else {
        urlPath = redirectPath;
    }
    if (urlPath.startsWith('/')) {
        urlPath = urlPath.slice(1);
    }
    return urlPrefix + "/" + urlPath;
};
export var getIdentityUrl = function (redirectOptions, options, prefillOptions, selectedLayout) {
    if (options === void 0) { options = defaultIdentityUrlOptions; }
    if (prefillOptions === void 0) { prefillOptions = {}; }
    var identityServicePageUrl = options.identityMode === 'signup'
        ? IDENTITY_SERVICE_SIGNUP_URL
        : IDENTITY_SERVICE_AUTH_URL;
    var selectedIdentityLayout = selectedLayout || DDFB_IDENTITY_LAYOUTS.CONSUMER_WEB;
    // COPS session flow
    // in this flow, only redirectOptions.nextPath matters.
    var authState = readCookie('authState') || '';
    var stateInNewSessionFlow = "" + (redirectOptions.nextPath || PORTAL_ROUTE_PREFIX) + (Boolean(authState) ? '||' + authState : '');
    var copsBasedIdentityUrlParams = {
        clientId: IDENTITY_SERVICE_WEB_BFF_CLIENT_ID,
        layout: selectedIdentityLayout,
        scope: '*',
        prompt: 'none',
        responseType: 'code',
        state: stateInNewSessionFlow,
        redirectUri: "" + IDENTITY_SERVICE_DEFAULT_REDIRECT_BASE_URL + IDENTITY_SERVICE_POST_LOGIN_PATH,
        email: prefillOptions.email || '',
        phone: prefillOptions.phone || '',
        firstName: prefillOptions.firstName || '',
        lastName: prefillOptions.lastName || '',
        companyName: prefillOptions.companyName || '',
    };
    var identityUrlParams = copsBasedIdentityUrlParams;
    return identityServicePageUrl + "/?" + queryString.stringify(snakeCaseObjectKeys(identityUrlParams));
};
/**
 *
 * @param {String} nextPath the path on doordash.com that the user will be redirected back to after logout.
 * in new session flow, there is no effect
 */
export var getLogoutUrl = function (nextPath) {
    var copsBasedIdentityUrlParams = {
        clientId: IDENTITY_SERVICE_WEB_BFF_CLIENT_ID,
        redirectUrl: getRedirectUrl({
            nextPath: nextPath ? nextPath : IDENTITY_SERVICE_POST_LOGOUT_PATH + "/",
        }),
    };
    var identityUrlParams = copsBasedIdentityUrlParams;
    return IDENTITY_SERVICE_BASE_URL + "/logout?" + queryString.stringify(snakeCaseObjectKeys(identityUrlParams));
};
